/*
================================================================ 
         Copyright (c) 2018-2021 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { Component } from "react";
import { connect } from "react-redux";
import actionTypes from "../../../store/actions";
import Breadcrumb from "../../../component/breadcrumb";
import ManageCustomersHierarchy from "../manageCustomers/manageCustomersHierarchy";
import { withTranslation } from "react-i18next";
import { Grid } from "@mui/material";
import { UsersIcon } from "../../../component/icons/icons";
import Button from "../../../component/button";
import { withNavigation } from "../../../helper/withNavigation";

// Manage order page class
class Subscriptions extends Component {
  // Declare property values that belongs to the component
  state = {
    bread: [{ title: this.props.t("SUBSCRIPTIONS"), url: "/subscriptions" }],
    display: false,
    isMobile: false,
    showCustomerList: false,
  };

  // Intial HTTP calls or data manipulation on page load
  componentDidMount() {
    this.updateIsMobile();
    window.addEventListener("resize", this.updateIsMobile);
    this.props.setCompDidMount();
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateIsMobile);
  }
  updateIsMobile = () => {
    const isMobile = window.matchMedia("(max-width: 960px)").matches;
    this.setState({ isMobile });
  };

  toggleShowCustomerList = () => {
    this.setState((prevState) => ({
      showCustomerList: !prevState.showCustomerList,
    }));
  };

  changeRoute = (data) => {
    this.props.router.navigate("/newOrder", { state: data });
  };

  goToQuote = (id, type) => {
    if (type && type === "order") {
      this.props.router.navigate({
        pathname: "/order/" + id,
      });
    } else {
      this.props.router.navigate({
        pathname: "/quote/" + id,
      });
    }
  };
  // Render order view
  render() {
    const { t } = this.props;
    const { isMobile, showCustomerList } = this.state;
    return (
      <div className={"newContentWrapper"}>
        <div className={"breadcrumbWrapper"}>
          <div className={"breadcrumbContent"}>
            <Grid container>
              <Grid
                item
                size={{
                  xs: 12,
                }}
              >
                <Breadcrumb list={this.state.bread} />
              </Grid>
              {isMobile && (
                <Grid
                  item
                  style={{ textAlign: "right" }}
                  size={{
                    xs: 12,
                  }}
                >
                  <Button
                    className="buttonSecondary"
                    onClick={this.toggleShowCustomerList}
                  >
                    <span
                      style={{ marginRight: ".25rem", verticalAlign: "middle" }}
                    >
                      <UsersIcon />
                    </span>
                    {t("SHOW_CUSTOMER_LIST")}
                  </Button>
                </Grid>
              )}
            </Grid>
          </div>
        </div>
        <main>
          <ManageCustomersHierarchy
            screen="subscriptions"
            changeRoute={this.changeRoute}
            goToQuote={this.goToQuote}
            isMobile={isMobile}
            showCustomerList={showCustomerList}
            toggleShowCustomerList={this.toggleShowCustomerList}
          />
        </main>
      </div>
    );
  }
}

// Set data to redux store
const mapDispatchToProps = (dispatch) => {
  return {
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
    setCompDidMount: () =>
      dispatch({ type: actionTypes.GLOBAL_COMP_DID_MOUNT }),
  };
};

export default connect(
  null,
  mapDispatchToProps,
)(withTranslation("translations")(withNavigation(Subscriptions)));
